import { useEffect } from "react";

/**
 * Attaches an IntersectionObserver that toggles `in-view` on any element
 * carrying the `.reveal` or `.reveal-left` class. Runs once on mount.
 */
export default function useReveal() {
  useEffect(() => {
    const targets = document.querySelectorAll(".reveal, .reveal-left");
    if (!("IntersectionObserver" in window)) {
      targets.forEach((el) => el.classList.add("in-view"));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" },
    );
    targets.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
}
